import { jsx as e } from "react/jsx-runtime";
function o(l) {
  return /* @__PURE__ */ e("svg", { height: "1em", viewBox: "0 0 16 16", width: "1em", ...l, children: /* @__PURE__ */ e(
    "path",
    {
      d: "M13.413 7.66L9.636 3.255c-.164-.23-.504-.23-.713-.041a.516.516 0 00-.042.72l3.045 3.548H2.965A.51.51 0 002.462 8a.51.51 0 00.503.518h8.96l-3.044 3.547c-.2.198-.143.539.066.727.209.188.525.175.69-.047l3.776-4.405a.52.52 0 00.125-.34.657.657 0 00-.125-.34z",
      fill: "currentColor",
      fillRule: "evenodd"
    }
  ) });
}
export {
  o as default
};
